import { FC } from 'react';
import { Oval } from 'react-loader-spinner';

interface IProps {
  height?: number;
  width?: number;
}

export const Loader: FC<IProps> = ({ height = 60, width = 60 }) => {
  return (
    <div className="louder-wrapper-custom">
      <Oval secondaryColor="grey" color="#0a49a5" height={height} width={width} />
    </div>
  );
};
